import {useEffect, useState} from 'react';
import {SelectInput} from '../utils/SelectInput';
import {useDispatch, useSelector} from 'react-redux';
import {responseSelector} from '../utils/utils';
import {alertTypes, useAlerts} from '../ui/alert';
import {
  getUsuariosForSelectDuck,
  getUsuariosForSelectThunk,
} from '../oportunidades/duck';

export const UsuariosSelect = ({usuarios, setUsuarios, token}) => {
  const dispatch = useDispatch();

  const modelUsuarios = useSelector(state => state.getUsuariosForSelect);

  const [usuariosOptions, setUsuariosOptions] = useState([]);

  const {setTopAlert} = useAlerts();

  useEffect(() => {
    console.log('UsuariosSelect.mounted');
    dispatch(getUsuariosForSelectThunk({userToken: token.raw}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(modelUsuarios);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(getUsuariosForSelectDuck.actions.clear());
    }

    if (data) {
      setUsuariosOptions(data?.data);
      dispatch(getUsuariosForSelectDuck.actions.clear());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelUsuarios]);

  return (
    <SelectInput
      label="Integrantes"
      value={usuarios}
      options={usuariosOptions}
      setValue={setUsuarios}
      isMulti
      required
    />
  );
};
